import { lineProps } from '../data/lineProps';

const getLineWeight = (lineName) => {
    return (
        lineProps.find((item) => item.name.includes(lineName.toLowerCase()))
            ?.wheigth ?? 1
    );
};

const calculateUsedWeight = (lines) => {
    if (!lines || lines.length === 0) return 0;
    return lines.reduce((total, item) => {
        const itemName = item.plan.extra
            ? item.plan.extra.extName
            : item.plan.nombreCode;
        return total + getLineWeight(itemName || '');
    }, 0);
};

export { getLineWeight, calculateUsedWeight };
